module.exports = __webpack_public_path__ + "static/media/22ESCWA24.badb25d3.jpg";